<template>
  <v-app
    :style="{ backgroundImage: 'url(/background.png)' }"
    style="background: #3e6187"
  >
    <v-main>
      <v-container class="fill-height align-end" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" md="4" sm="8">
            <transition appear @before-enter="beforeEnter" @enter="enter">
              <v-card
                class="text-center"
                height="599"
                elevation="2"
                style="border-radius: 14px"
              >
                <div style="width: 65%; margin: 0 auto">
                  <img
                    src="../../../public/img/group.jpg"
                    height="30"
                    class="mt-12"
                    alt=""
                  />
                  <slot />
                  <v-card-actions style="padding: 0px !important">
                    <slot name="action" />
                    <v-spacer />
                  </v-card-actions>
                </div>
                <div
                  style="
                    align-items: flex-end;
                    display: flex;
                    justify-content: center;
                  "
                >
                  <slot name="link" />
                </div>
              </v-card>
            </transition>
          </v-col>
        </v-row>
        <v-row style="margin-bottom: 10px">
          <v-col></v-col>
          <v-col
            style="
              align-items: flex-end;
              display: flex;
              justify-content: center;
            "
          >
            <div class="d-flex justify-center align-center">
              <img src="/img/invanp.png" height="12" alt="" />
              <p
                class="mx-6 white--text"
                style="
                  font-family: 'Montserrat', sans-serif;
                  font-style: normal;
                  font-weight: bold;
                  font-size: 14px;
                  line-height: 143.4%;
                "
              >
                Контакты
              </p>
              <p
                class="white--text"
                style="
                  font-family: 'Montserrat', sans-serif;
                  font-style: normal;
                  font-weight: bold;
                  font-size: 14px;
                  line-height: 143.4%;
                "
              >
                Политика конфиденциальности
              </p>
            </div>
          </v-col>
          <v-col>
            <div class="d-flex justify-end">
              <div
                style="background: white; width: 200px; border-radius: 10px"
                class="d-flex mr-8"
              >
                <img
                  height="30"
                  class="mt-1 mb-1 ml-3"
                  src="/img/message-question.svg"
                  alt=""
                />
                <p
                  style="
                    font-family: Montserrat, sans-serif;
                    font-style: normal;
                    font-weight: 600;
                    font-size: 13px;
                    line-height: 143.4%;
                    color: #3e6187;
                    margin-top: 10px;
                  "
                  class="ml-2"
                >
                  Служба поддержки
                </p>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
export default {
  name: "v-authorization",
  props: {
    title: String,
  },
};
</script>
<style scoped>
.v-application p {
  margin-bottom: 0px !important ;
}
</style>